var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 11.9984C3.6 12.1184 3.73 12.2684 3.88 12.4284C4.34 12.9284 5.01 13.5984 5.83 14.2584C7.5 15.6084 9.68 16.8484 11.99 16.8484C14.3 16.8484 16.48 15.6084 18.15 14.2584C18.97 13.5884 19.64 12.9284 20.1 12.4284C20.25 12.2684 20.38 12.1184 20.48 11.9984C20.38 11.8784 20.25 11.7284 20.1 11.5684C19.64 11.0684 18.97 10.3984 18.15 9.73844C16.48 8.38844 14.3 7.14844 11.99 7.14844C9.68 7.14844 7.5 8.38844 5.83 9.73844C5.01 10.4084 4.34 11.0684 3.88 11.5684C3.73 11.7284 3.6 11.8784 3.5 11.9984Z",
    stroke: "#0d4892",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 14.5531C13.4804 14.5531 14.6803 13.4115 14.6803 12.0031C14.6803 10.5948 13.4804 9.45312 12.0003 9.45312C10.5202 9.45312 9.32031 10.5948 9.32031 12.0031C9.32031 13.4115 10.5202 14.5531 12.0003 14.5531Z",
    stroke: "#0d4892",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.f12e4b521779ed057670be9a7e75f85e.svg";
export { ForwardRef as ReactComponent };